// Shared option data — used by ProductDetail and QuickAddModal.
// Keep this as the single source of truth so the two never drift apart.

// Based on Japanese Ring Size Guide
export const SIZE_DATA = [
  { mm: 14.9, us: "4",    jp: 7  },
  { mm: 15.3, us: "4½",  jp: 8  },
  { mm: 15.7, us: "5",    jp: 9  },
  { mm: 16.1, us: "5½",  jp: 10 },
  { mm: 16.5, us: "6",    jp: 11 },
  { mm: 16.9, us: "6½",  jp: 13 },
  { mm: 17.3, us: "7",    jp: 14 },
  { mm: 17.7, us: "7½",  jp: 15 },
  { mm: 18.1, us: "8",    jp: 16 },
  { mm: 18.5, us: "8½",  jp: 17 },
  { mm: 19.0, us: "9",    jp: 19 },
  { mm: 19.4, us: "9½",  jp: 20 },
  { mm: 19.8, us: "10",   jp: 21 },
  { mm: 20.2, us: "10½", jp: 22 },
];

export const CERT_OPTIONS = [
  { value: "none", label: "No Certificate", desc: "Standard packaging", price: 0 },
  { value: "card", label: "Card Certificate", desc: "Compact card format", price: 2300 },
  { value: "book", label: "Book Certificate", desc: "Premium booklet format", price: 3000 },
];

export const isRingProduct = (product) =>
  product?.category === "ring" || product?.id?.startsWith("ring-");